export default class FilterItem {
  constructor({ name, value, isIconPresent, color, icon }) {
    this.name = name;
    this.value = value;
    this.isIconPresent = isIconPresent;
    this.color = color;
    this.icon = icon;
  }
}
